import { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiUserPlus, FiPhone, FiCalendar, FiDollarSign, FiUser } from 'react-icons/fi';
import { toast } from 'react-toastify';
import helperService from '../services/helperService';
import Button from '../components/Button';
import './DetailView.css';

const HelperView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [helper, setHelper] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHelper();
  }, [id]);

  const fetchHelper = async () => {
    try {
      const response = await helperService.getById(id);
      setHelper(response.data);
    } catch (error) {
      toast.error('Failed to fetch helper details');
      navigate('/helpers');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!helper) {
    return null;
  }

  const getStatusBadge = (status) => {
    const statusMap = {
      available: 'badge-success',
      on_site: 'badge-primary',
      off_duty: 'badge-gray',
      on_leave: 'badge-warning',
    };
    return `badge ${statusMap[status] || 'badge-gray'}`;
  };

  return (
    <div className="detail-view-container">
      <div className="detail-header">
        <button onClick={() => navigate('/helpers')} className="back-button">
          <FiArrowLeft /> Back to List
        </button>
        <Link to={`/helpers/${id}/edit`}>
          <Button variant="primary" icon={<FiEdit />}>
            Edit Helper
          </Button>
        </Link>
      </div>

      <div className="detail-card">
        <div className="detail-hero" style={{ background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }}>
          <div className="hero-avatar">
            <FiUserPlus />
          </div>
          <div className="hero-info">
            <h1 className="hero-title">{helper.name}</h1>
            <p className="hero-subtitle">Employee ID: {helper.employeeId}</p>
            <span className={getStatusBadge(helper.status)}>
              {helper.status.replace('_', ' ')}
            </span>
          </div>
        </div>

        <div className="detail-sections">
          <div className="detail-section">
            <h3 className="section-title">Contact Information</h3>
            <div className="info-grid">
              <div className="info-item">
                <FiPhone className="info-icon" />
                <div>
                  <span className="info-label">Phone</span>
                  <span className="info-value">{helper.phone}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3 className="section-title">Employment Details</h3>
            <div className="info-grid">
              {helper.assignedTo && (
                <div className="info-item">
                  <FiUser className="info-icon" />
                  <div>
                    <span className="info-label">Assigned To</span>
                    <span className="info-value">{helper.assignedTo.name}</span>
                  </div>
                </div>
              )}
              <div className="info-item">
                <FiDollarSign className="info-icon" />
                <div>
                  <span className="info-label">Monthly Salary</span>
                  <span className="info-value">₹{helper.salary?.toLocaleString() || 'N/A'}</span>
                </div>
              </div>
              <div className="info-item">
                <FiCalendar className="info-icon" />
                <div>
                  <span className="info-label">Joining Date</span>
                  <span className="info-value">
                    {new Date(helper.joiningDate).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelperView;
